import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import type { EntityState } from "@@/shared/entity-status";
import type { MetaContent } from "@@/shared/meta-content/meta-content";
import type { Price } from "@@/shared/prices/price";
import type { ProviderId } from "@@/shared/providers/provider-id";
import type { ShippingId} from "../shipping-id";
import { shippingIdFactory } from "../shipping-id";
import type { ShippingSlot } from "../shipping-slot";
import type { ZonePrice } from "../zone-price";

type LoopShipping = {
    readonly _id: ShippingId;
    readonly _type: "SHIPPING";
    readonly _status: EntityState;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly shippingType: "LOOP";
    readonly provider: ProviderId;
    readonly meta: MetaContent;
    readonly price: Price;

    readonly zonePrices?: ZonePrice[];
    /**
     *
     *
     * @type {(ShippingSlot[])}
     */
    readonly availability: ShippingSlot[];

    readonly options: {
        /**
         *The default time we use to
         *
         * @type {(ShippingSlot[])}
         */
        readonly pickupTime: DurationInMinutes;
        /**
         *How many minutes before the slot starts we stop orders to handle routing.
         *
         * @type {(ShippingSlot[])}
         */
        readonly cutOff: DurationInMinutes;
    };
};

const loopShippingFactory = (
    params: Omit<
        LoopShipping,
        "_id" | "_type" | "_status" | "_createdAt" | "shippingType"
    >,
): LoopShipping => {
    return {
        ...params,
        _id: shippingIdFactory(),
        _type: "SHIPPING",
        _status: "ACTIVE",
        _createdAt: nowIsoAndUnix(),
        shippingType: "LOOP",
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isLoopShipping = (shipping: any): shipping is LoopShipping => {
    return (
        "_type" in shipping &&
        shipping._type === "SHIPPING" &&
        "shippingType" in shipping &&
        shipping.shippingType === "LOOP"
    );
};

export { isLoopShipping, loopShippingFactory };
export type { LoopShipping };
